export default {"src":"/expo/_next/static/media/shadow.493a7782.svg","height":389,"width":714,"blurWidth":0,"blurHeight":0};